import React from 'react';
import Styles from './CleanButton.css';
/**
 * @description Componente tag button de um botão sem bordas e sem background
 */
function CleanButton({ ...props }) {
  return (
    <>
      <button {...props} className={`clean-button ${props.className}`} />
      <style jsx>{Styles}</style>
    </>
  );
}

export default CleanButton;
